import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgb(var(--primary-color, 25, 118, 210))",
      contrastText: "#fff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          borderRadius: "4px",
          padding: "4px 16px",
          fontSize: "1rem",
        },
        containedPrimary: {
          backgroundColor: "#5d78ff",
          color: "white",
          "&:hover": {
            backgroundColor: "#5d78ff",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
        },
      },
    },
    MuiTextField : {
      styleOverrides : {
        root : {
          "&.label" : {
            fontSize : "3rem",
          }
        }
        
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.25rem",
          fontWeight: 500,
        },
      },
    },
    MuiTableCell : {
      styleOverrides : {
        root : {
          fontSize : "1rem"
        }
      }
    },
    MuiStepLabel : {
      styleOverrides : {
        label: {
          fontSize: "1.3rem",   // changes the label text size
          fontWeight: 500,
        },
      }
    },
    MuiSvgIcon : {
      styleOverrides : {
        root : {
          // fontSize : "2.9rem"
        }
      }
    }
  },
});

export default theme;
